import { render, staticRenderFns } from "./EmbedSkillSim.vue?vue&type=template&id=287f6db5&"
import script from "./EmbedSkillSim.vue?vue&type=script&lang=ts&"
export * from "./EmbedSkillSim.vue?vue&type=script&lang=ts&"
import style0 from "./EmbedSkillSim.vue?vue&type=style&index=0&lang=less&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports